module.exports = __webpack_public_path__ + "static/bg3-3d585f011212332327d9c0960a005925.png";